import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const ChartCard = styled.div`
  background: ${ColorV2.White};
  border: 1.5px solid ${ColorV2.Blue5};
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ChartHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ChartControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ChartTitle = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 280px;
`;
